import createVueApp from '@phoenix/createVueApp';
import CountrySelectorModal from '@maison/components/organisms/modals/CountrySelectorModal.vue';

const app = createVueApp();
app.component('CountrySelectorModal', CountrySelectorModal);
app.mount('#phoenix-country-selector-modal');
